// extracted by mini-css-extract-plugin
export default {"spinLoader":"styles_spinLoader__yBlIy","spin":"styles_spin__ViFb4"};